import { Formik, Form } from "formik";
import * as Yup from "yup";
import MainLayout from "../../layout";
import FormTextField from "../../components/form/text";
import { useNavigate, useParams } from "react-router-dom";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import { useEffect, useState } from "react";
import { FormTextAreaField } from "../../components/form/text-area";
import { FormImageField } from "../../components/form/image";
import { FormMultiImageField } from "../../components/form/multi-image";
import { FormDropDown } from "../../components/form/dropdown";
import { api } from "../../redux/apis/api";

const EditProduct = () => {
  const naviagte = useNavigate();
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [userList, setuserList] = useState([]);

  const initialValues = {
    id: params?.id,
    name: data?.name ?? "",
    price: data?.price ?? "",
    description: data?.description ?? "",
    photo_url: data?.photo_url ?? "",
    photos: data?.photos?.length > 0 ? data?.photos : [],
    hsn_code: data?.hsn_code ?? "",
    cgst: data?.cgst ?? "",
    sgst: data?.sgst ?? "",
    igst: data?.igst ?? "",
    status: data?.status ?? "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    api
      .post(`/product/edit`, values)
      .then((response) => {
        successToast(response.message);
        naviagte(`/product/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/product/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const statusOptions = [
    {
      label: "Active",
      value: "active",
    },
    {
      label: "Inactive",
      value: "inactive",
    },
    {
      label: "Draft",
      value: "draft",
    },
  ];

  const fetchUserDropDownData = () => {
    api
      .get(`/ffadmin/user-list-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.users?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setuserList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    fetchUserDropDownData();
  }, []);

  return (
    <MainLayout>
      <section className="h-full overflow-auto md:px-3">
        {loading ? (
          <div className="h-full flex justify-center items-center">
            <div>
              <div className="animate-spin rounded-full h-10 w-10 border-4 border-primary border-t-transparent mx-2"></div>
              <p className="mt-2 text-sm text-gray-500">Loading...</p>
            </div>
          </div>
        ) : (
          <>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize={true}
            >
              {({ values }) => (
                <Form>
                  <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                    <h2 className="text-xl font-semibold capitalize">
                      product - Edit
                    </h2>
                    <div className="flex gap-3 items-center">
                      <button
                        onClick={() => naviagte("/product/list")}
                        type="button"
                        className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                      >
                        Save
                      </button>
                    </div>
                  </div>

                  <section className="w-full max-w-[40rem]">
                    <div className="my-4">
                      <FormTextField
                        name={"name"}
                        label={"product name"}
                        placeholder={`Enter product name`}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"price"}
                        label={"product price"}
                        placeholder={`Enter product price`}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextAreaField
                        name={"description"}
                        label={"product description"}
                        placeholder={`Enter product description`}
                        rows={3}
                      />
                    </div>
                    <div className="my-4">
                      <FormImageField name={"photo_url"} label={"photo url"} />
                    </div>
                    <div className="my-4">
                      <FormMultiImageField name={"photos"} label={"photos"} />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"hsn_code"}
                        label={"product hsn code"}
                        placeholder={`Enter product hsn code`}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"cgst"}
                        label={"product cgst"}
                        placeholder={`Enter product cgst`}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"sgst"}
                        label={"product sgst"}
                        placeholder={`Enter product sgst`}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"igst"}
                        label={"product igst"}
                        placeholder={`Enter product igst`}
                      />
                    </div>
                    <div className="my-4">
                      <FormDropDown
                        name="status"
                        label="status"
                        options={statusOptions}
                        value={statusOptions?.find(
                          (item) => item?.value === values?.status
                        )}
                        menuPlacement="top"
                      />
                    </div>
                  </section>
                </Form>
              )}
            </Formik>
          </>
        )}
      </section>
    </MainLayout>
  );
};

export default EditProduct;
